import {
  IUL_PAGE_WORDING_IUL_EXPERIMENT,
  IUL_PAGE_WORDING_PERMANENT_EXPERIMENT,
} from 'lib/@getethos/experiments/constants'
import { useDecisionForFlag } from 'lib/FeaturesAndExperiments/getDecisionForFlag'

import { useIsIulPage } from '../content/useIsIulPage'

export const useIulPageWordingIulExperiment = () => {
  const isIulPage = useIsIulPage()

  const { isLoading, variation, isEnabled } = useDecisionForFlag({
    name: IUL_PAGE_WORDING_IUL_EXPERIMENT.EXPERIMENT_KEY,
    fallbackVariation: IUL_PAGE_WORDING_IUL_EXPERIMENT.VARIATIONS.OFF,
    bypassActivate: !isIulPage,
  })

  return {
    isLoading,
    isIulWordingExperimentEnabled:
      isEnabled && variation === IUL_PAGE_WORDING_IUL_EXPERIMENT.VARIATIONS.ON,
  }
}

export const useIulPageWordingPermanentExperiment = () => {
  const isIulPage = useIsIulPage()

  const { isLoading, variation, isEnabled } = useDecisionForFlag({
    name: IUL_PAGE_WORDING_PERMANENT_EXPERIMENT.EXPERIMENT_KEY,
    fallbackVariation: IUL_PAGE_WORDING_PERMANENT_EXPERIMENT.VARIATIONS.OFF,
    bypassActivate: !isIulPage,
  })

  return {
    isLoading,
    isPermanentWordingExperimentEnabled:
      isEnabled &&
      variation === IUL_PAGE_WORDING_PERMANENT_EXPERIMENT.VARIATIONS.ON,
  }
}
